module.exports = __webpack_public_path__ + "static/media/door.aa938969.svg";